import { useV2ListServiceCategorysForAccountQuery } from "@generated";

const useListServiceCategories = () => {
  const { data, error, isLoading, refetch } =
    useV2ListServiceCategorysForAccountQuery({});

  return {
    serviceCategories: data?.data || [],
    error,
    isLoading,
    refetch,
  };
};

export default useListServiceCategories;
